export const regionOptions = [
  {
    title: 'COMMON.regionOptions.___tw',
    tag: 'TW',
    value: 'TW',
    link: 'tw.edge.inherinext.com'
  },
  // {
  //   title: 'COMMON.regionOptions.___us',
  //   tag: 'US',
  //   value: 'US',
  //   link: 'us.edge.inherinext.com'
  // },
  {
    title: 'COMMON.regionOptions.___jp',
    tag: 'JP',
    value: 'JP',
    link: 'edge.inherinext.jp'
  }
]